import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  HStack,
  Icon,
  Box,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePatchUserMetaData } from '../../../../../../app/src/features/api/userData';
import useTracking from '../../../../../../common/src/hooks/tracking/useTracking';
import GrayTextBox from '../../../../../../company-scan/components/GrayTextBox';

interface Props {
  isOpen: boolean;
  onDecline: () => void;
  onAccept: () => void;
}

const DocExtractAcknowledgementModal: React.FC<Props> = ({
  isOpen,
  onDecline,
  onAccept,
}) => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();
  const { mutateAsync: patchUserMetaData, isLoading } = usePatchUserMetaData();

  const handleDecline = () => {
    trackEvent('User declined Doc extraction Acknowledgement');
    patchUserMetaData({
      metadata: { doc_extraction_acknowledgement: false },
    });
    onDecline();
  };

  const handleAgree = async () => {
    trackEvent('User agreed to Doc extraction Acknowledgement');
    await patchUserMetaData({
      metadata: { doc_extraction_acknowledgement: true },
    });
    onAccept();
  };

  return (
    <Modal isOpen={isOpen} onClose={onDecline} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t('TOOLKIT_DOC-EXTRACTION_ACKNOWLEDGEMENT-MODAL_TITLE')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          sx={{
            p: {
              marginBottom: '2',
            },
            ul: {
              listStyleType: 'circle',
              paddingLeft: '4',
            },
            li: {
              marginBottom: '0.5',
            },
          }}
        >
          <GrayTextBox
            title={t('TOOLKIT_DOC-EXTRACTION_ACKNOWLEDGEMENT-MODAL-BODY_TITLE')}
          >
            <Box
              dangerouslySetInnerHTML={{
                __html: t(
                  'TOOLKIT_DOC-EXTRACTION_ACKNOWLEDGEMENT-MODAL_DESCRIPTION',
                ),
              }}
            />
          </GrayTextBox>
        </ModalBody>
        <ModalFooter as={HStack} spacing={3}>
          <Button
            variant="dangerPrimary"
            onClick={handleDecline}
            leftIcon={<Icon name="GeneralActionsCloseOrRemove" />}
          >
            {t('DECLINE')}
          </Button>
          <Button
            variant="successPrimary"
            onClick={handleAgree}
            leftIcon={<Icon name="GeneralStatusSuccessCheckmark" />}
            isLoading={isLoading}
          >
            {t('AGREE')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DocExtractAcknowledgementModal;
